"use client";


export default function WhyChooseUs() {
  return (
    <section className="relative overflow-hidden py-12 lg:py-[4.5rem] w-full flex flex-col items-center justify-center">
      <div className="absolute top-6 right-8 z-20">
        <a
          href="/contact"
          className="px-5 py-2 rounded-md font-medium text-foreground hover:underline transition-colors"
        >
          Contact Us
        </a>
      </div>
      <div className="container mx-auto px-5 md:px-8 lg:px-0 flex flex-col items-center">
        <a
          href="/"
          className="text-3xl lg:text-4xl font-bold mt-2 mb-6 text-center font-extrabold uppercase tracking-wide bg-gradient-to-r from-pink-400 via-fuchsia-500 to-purple-700 bg-clip-text text-transparent drop-shadow-lg lg:text-[2.4rem] focus:outline-none"
          aria-label="Go to homepage"
        >
          AetherSIM
        </a>
        <p className="text-foreground/80 mb-10 text-center max-w-2xl">
          <span className="lg:text-[1.3rem]"></span>
        </p>
      </div>
    </section>
  );
}
